import React from 'react';
import PropTypes from 'prop-types'
import AgentListHeaderSortLink from './AgentListHeaderSortLink';
import HrbTranslate from '../../../../components/language/HrbTranslate';

const AgentListSortHeader = ({ sortKey, isReversed, onSortChanged, renderLinks }) => {

    return (
        <div className='agent-sort columns'>
            <div className='column is-10 is-offset-1 columns px-1 my-0 py-1 level'>
                <div className='column is-6 pl-0 level-item'>
                    {renderLinks ?
                        <AgentListHeaderSortLink sortKey='name' currentSortKey={sortKey} isReversed={isReversed} onClick={onSortChanged} renderLink={renderLinks}>
                            <HrbTranslate text='ManageTicket.Assignee' />
                        </AgentListHeaderSortLink>
                        :
                        <HrbTranslate text='ManageTicket.Assignee' className='header-sort-link' />
                    }
                </div>
                <div className='column is-4 pl-0 level-item'>
                    {renderLinks ?
                        <AgentListHeaderSortLink sortKey='office' currentSortKey={sortKey} isReversed={isReversed} onClick={onSortChanged} renderLink={renderLinks}>
                            <HrbTranslate text='ManageTicket.Office' />
                        </AgentListHeaderSortLink>
                        :
                        <HrbTranslate text='ManageTicket.Office' className='header-sort-link' />
                    }
                </div>
                <div className='column is-2 pl-0 level-item'>
                    <HrbTranslate text='ManageTicket.Select' className='header-sort-link' />
                </div>
            </div>
        </div>
    );
}

AgentListSortHeader.propTypes = {
    sortKey: PropTypes.string,
    isReversed: PropTypes.bool,
    onSortChanged: PropTypes.func.isRequired,
    renderLinks: PropTypes.bool
}

export default AgentListSortHeader